import useAuth from "hooks/useAuth";
import moment from "moment-timezone";

export const flattenErrors = (obj, prefix = "") => {
  const errors = {};
  for (const key in obj) {
    const value = obj[key];
    const path = prefix ? `${prefix}[${key}]` : key;

    if (typeof value === "string") {
      errors[path] = value;
    } else if (Array.isArray(value)) {
      // If it's an array of strings, take the first one
      if (value.length > 0 && typeof value[0] === "string") {
        errors[path] = value[0]; // or join them with `value.join(', ')` if needed
      }
    } else if (typeof value === "object" && value !== null) {
      Object.assign(errors, flattenErrors(value, path));
    }
  }
  return errors;
};

export const formatDateWithFormat = (date, format) => {
  if (!date) return null;
  const { user } = useAuth();
  if (user?.timezone) {
    return moment(date).tz(user.timezone).format(format);
  }
  return moment(date).format(format);
};
